(ns ui.user-session
  "Reads the logged-in organization from the `:query/user-session`
   result (cljs) or from the server-side session (clj), for UI parts
   that render on both sides."
  #?(:cljs (:require [parts.replicant.query :as query])))

(def query
  {:query/kind :query/user-session})

(defn org-uuid
  "The `:organization/uuid` of the logged-in organization, nil while the
   session is still loading or on a logged-out surface."
  [w]
  #?(:cljs (:organization/uuid (query/get-result w query))
     :clj (:organization/uuid (:user/session w))))
